export class PrimaryBrandClickEvent extends Event {
   static EVENT_NAME = 'sidebar-primary-brand-click';
   constructor() {
      super(PrimaryBrandClickEvent.EVENT_NAME, {
         bubbles: true,
         composed: true,
      });
   }
}

export class SecondaryBrandClickEvent extends Event {
   static EVENT_NAME = 'sidebar-secondary-brand-click';
   constructor() {
      super(SecondaryBrandClickEvent.EVENT_NAME, {
         bubbles: true,
         composed: true,
      });
   }
}

export class SidebarItemClickEvent extends Event {
   static EVENT_NAME = 'sidebar-item-click';
   constructor() {
      super(SidebarItemClickEvent.EVENT_NAME, {
         bubbles: true,
         composed: true,
      });
   }
}

export class ToggleSidebarEvent extends Event {
   static EVENT_NAME = 'toggle-sidebar';
   constructor() {
      super(ToggleSidebarEvent.EVENT_NAME, { bubbles: true, composed: true });
   }
}
